import React from 'react';
import SimpleStartTimeCell from 'main/components/show/cuesheet.util/SimpleStartTimeCell';
import SimplePresetDurationCell from 'main/components/show/cuesheet.util/SimplePresetDurationCell';
import SimpleDurationCell from 'main/components/show/cuesheet.util/SimpleDurationCell';
import CuesheetHelper from 'flux/helpers/cuesheetHelper';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';

export const startTimeCellRenderer = (
  item,
  rowIndex,
  user,
  event,
  cuesheet,
) => {
  const show = cuesheet.get('show');

  const isSelected = CuesheetHelper.isCellSelected(
    rowIndex,
    EditableCellTypes.ItemStartTime,
    cuesheet,
  );

  const props = {
    item,
    user,
    displayStartTime: show.get('displayStartTime'),
    isSelected,
    showStartOn: show.get('startOn'),
    timeZone: event.get('timeZone'),
    twentyFourHourClock: event.get('twentyFourHourClock'),
    rowIndex,
    userId: user.get('_id'),
  };

  return <SimpleStartTimeCell simple {...props} />;
};

export const durationCellRenderer = (
  item,
  rowSpec,
  rowIndex,
  user,
  event,
  cuesheet,
) => {
  const show = cuesheet.get('show');
  const isTracked = rowSpec.has('tracked');

  const props = {
    item,
    rowIndex,
    displayDuration: show.get('displayDuration'),
    displayActualDuration: show.get('displayActualDuration'),
    durationDisplayType: show.get('durationDisplayType'),
    isSelected: CuesheetHelper.isCellSelected(
      rowIndex,
      EditableCellTypes.ItemDuration,
      cuesheet,
    ),
    eventId: event.get('_id'),
    user,
    isTracked,
  };

  return <SimpleDurationCell showRunTimeSuppressionToggle simple {...props} />;
};

export const presetDurationCellRenderer = (
  item,
  rowIndex,
  event,
  user,
  cuesheet,
) => {
  const show = cuesheet.get('show');

  const props = {
    item,
    userId: user.get('_id'),
    rowIndex,
    eventId: event.get('_id'),
    teamId: event.get('team'),
    isSelected: CuesheetHelper.isCellSelected(
      rowIndex,
      EditableCellTypes.ItemPresetDuration,
      cuesheet,
    ),
    displayPresetDuration: show.get('displayPresetDuration'),
    presetDurationDisplayType: show.get('presetDurationDisplayType'),
    user,
  };

  return <SimplePresetDurationCell simple {...props} />;
};
